module.exports = __webpack_public_path__ + "static/media/provider_venn.b783c88e.png";